interface UnmutedVideoIconProps extends React.ComponentPropsWithRef<'svg'> {
  color?: string;
}

export function UnmutedVideoIcon({ color = 'currentColor', ...props }: UnmutedVideoIconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.3203 16.5C15.5258 15.6402 16.3203 14.1702 16.3203 12.5012C16.3203 10.8363 15.5298 9.36947 14.3293 8.50879"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.3858 7.02051C9.37164 6.25775 10.8037 6.96041 10.8037 8.20687V16.7933C10.8037 18.0398 9.37163 18.7425 8.38579 17.9797L5.18125 15.5002H3C2.44772 15.5002 2 15.0525 2 14.5002V10.5002C2 9.94795 2.44772 9.50024 3 9.50024H5.18086L8.3858 7.02051Z"
        fill={color}
      />
      <path
        d="M16.9766 19.9995C19.4011 18.387 20.999 15.6301 20.999 12.5001C20.999 9.37777 19.409 6.62682 16.9946 5.0127"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
